import * as Yup from 'yup';

export const bookedAcceptedSchema = Yup.object().shape({
  bookingReportPeriod: Yup
    .string()
    .required('This field may not be blank'),
});
